var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between"},[_c('BlackButton',{staticStyle:{"width":"46%"}},[_vm._v(_vm._s(_vm.black))]),_c('TooliabaButton',{staticStyle:{"width":"46%"}},[_vm._v(_vm._s(_vm.yellow))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }